import Vue from 'vue'
import Vuex from 'vuex'
import cleaning from './modules/cleaning'
import cocos from './modules/cocos'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    cleaning,
    cocos
  },
  strict: debug
})
